import script from "./AnaliseGraficaDocumentos_70.vue?vue&type=script&setup=true&lang=js"
export * from "./AnaliseGraficaDocumentos_70.vue?vue&type=script&setup=true&lang=js"

import "./AnaliseGraficaDocumentos_70.vue?vue&type=style&index=0&id=5af66046&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af66046"]])

export default __exports__